"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const analytics_js_1 = __importDefault(require("@hh.ru/analytics-js"));
/** Событие отправляется, когда реюме соискателя успешно обновлено после клика на кнопку Поднять в поиске. Платные автоподнятия не учитываются */
const resumeRenewCompleteExternal = () => analytics_js_1.default.sendEvent("applicant", "resume_renew_complete", "success");
exports.default = resumeRenewCompleteExternal;
